<template>
  <UiButton
    icon="$settings"
    variant="text"
    class="mx-auto"
    color="grey-600"
    @click="openColumns"
  ></UiButton>
</template>

<script setup lang="ts">
import UiButton from '../UiButton/UiButton.vue';

export interface Props {
  title: string;
  params: any;
}
const props = defineProps<Props>();

const openColumns = (): void => {
  if (props.params.api.getOpenedToolPanel() === null) {
    props.params.api.openToolPanel('columns');
  } else {
    props.params.api.closeToolPanel();
  }
};
</script>
